import { MHeaderProps } from "../../../../MHeader";
import { useHeaderProps } from "../../useHeaderProps";

/**
 * 这个组件是为了方便设置页头属性
 * @constructor
 */
export function SubLayoutHeader(props: Partial<MHeaderProps>) {
    useHeaderProps(props);
    return null;
}
